import { render, staticRenderFns } from "./editTheme.vue?vue&type=template&id=0cfea93e&scoped=true&"
import script from "./editTheme.vue?vue&type=script&lang=js&"
export * from "./editTheme.vue?vue&type=script&lang=js&"
import style0 from "./editTheme.vue?vue&type=style&index=0&id=0cfea93e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfea93e",
  null
  
)

export default component.exports